import { render, staticRenderFns } from "./ImagePlaceholder.vue?vue&type=template&id=1cf4af7e&scoped=true&"
import script from "./ImagePlaceholder.vue?vue&type=script&lang=ts&"
export * from "./ImagePlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./ImagePlaceholder.vue?vue&type=style&index=0&id=1cf4af7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf4af7e",
  null
  
)

export default component.exports